import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/agencies.css';


const Careers = () => {
    const underlineRef = useRef(null);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            { threshold: 0.1 }
        );

        const targets = document.querySelectorAll('.animate-slide');
        targets.forEach(target => observer.observe(target));

        return () => {
            targets.forEach(target => observer.unobserve(target));
        };
    }, []);



    return (
        <>
            {/* Hero Section */}
            <div className="container-fluid agencies-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0 ,top:'-122px'}}>
                <div className="container agencies-content">
                    <div className="row">
                        <div className="col-lg-6 col-md-8 col-12 agencies-text">
                            <h1 className="agencies-title text-white">Our Agencies.</h1>
                            <h2 className="agencies-subtitle">Petrochoice Integrated Services</h2>
                            <div className="agencies-underline" ref={underlineRef}></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Our Agencies Section */}
            <section className="py-5 agencies-section">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Image Left */}
                        <div className="col-lg-6 animate-slide">
                            <img
                                src="/assets/our-agencies.jpg" // Replace with your actual path
                                alt="Our Agencies"
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: '400px', objectFit: 'cover' }}
                            />
                        </div>

                        {/* Text Right */}
                        <div className="col-lg-6 animate-slide delay">
                            <h2 className="fw-bold mb-3" style={{ color: '#0c61c0' }}>Our Agencies</h2>
                            <p className="fs-5 text-muted">
                                Petrochoice have established partnerships with principles agencies and technology providers, enabling us to offer a comprehensive suite of solutions.
                                These agencies complement our services by providing specialized tools, software, and equipment to address specific industry challenges.
                                We continuously evaluate and collaborate with agencies to ensure our clients have access to the latest innovations.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            {/* Links to agencies pages */}
            <section className="py-5 agencies-section">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-md-4"><Link className="btn btn-outline-primary w-100" to="/agencies/bpm">Beijing Petroleum Machinery (BPM)</Link></div>
                        <div className="col-md-4"><Link className="btn btn-outline-primary w-100" to="/agencies/kci">Kinetics Controls & Innovation (KCI)</Link></div>
                        <div className="col-md-4"><Link className="btn btn-outline-primary w-100" to="/agencies/lanzhou-lspe">Lanzhou LS Petroleum Equipment</Link></div>
                        <div className="col-md-4"><Link className="btn btn-outline-primary w-100" to="/agencies/seismic-acquisition">Split Scientific Company</Link></div>
                        <div className="col-md-4"><Link className="btn btn-outline-primary w-100" to="/agencies/nnw">NNW Inc.</Link></div>
                    </div>
                </div>
            </section>




        </>
    );
};

export default Careers;
